import React from 'react';
import { Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { COLOR_WHITE } from '@monorepo/shared/src/themes/studentAppTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import gapBackground from 'assets/images/gap-background.png';
import gapBook from 'assets/images/gap-book.png';
import gapPaco from 'assets/images/gap-paco.png';

const tA11y = (key: string) => translate('a11y', key);
const tHome = (key: string) => translate('home', key);

type Props = {
  onClick: any;
  styles: { [key: string]: any };
  components: any;
};

const GreatAlphabetParadeIcon: React.FC<Props> = ({ onClick, styles, components }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.between('xs', 'md'));
  const classes = useStyles();

  return (
    <Box className={`${classes.gapAndPaco} ${isMobile ? classes.scale : ''}`} style={styles}>
      <Button
        className={`${classes.button} ${classes.gapBtn}`}
        disableTouchRipple
        onClick={onClick}
      >
        <div className={classes.gapBackgroundImg}>
          <img
            alt={tA11y('alt.greatAmericanParadeBook')}
            className={classes.gapBook}
            src={gapBook}
          />
          <Typography variant="h1" className={classes.gapText}>
            {tHome('greatAlphabetParade')}
          </Typography>
        </div>
      </Button>
      <img alt={tA11y('alt.paco')} className={classes.gapPaco} src={gapPaco} />
      {components && <div>{components}</div>}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  button: {
    '&:hover': {
      background: 'none',
    },
  },
  gapAndPaco: {
    left: '30vw',
    position: 'absolute',
    top: '55vh',
  },
  gapBtn: {
    left: remCalc(0),
    position: 'absolute',
    top: remCalc(0),
  },
  gapBackgroundImg: {
    backgroundImage: `url(${gapBackground})`,
    height: remCalc(230),
    position: 'relative',
    width: remCalc(223),
    zIndex: 1,
  },
  gapBook: {
    left: remCalc(-80),
    position: 'absolute',
    top: remCalc(40),
  },
  gapPaco: {
    left: remCalc(190),
    position: 'absolute',
    top: remCalc(-35),
  },
  gapText: {
    color: COLOR_WHITE,
    left: remCalc(30),
    lineHeight: remCalc(40),
    position: 'relative',
    textAlign: 'left',
    top: remCalc(50),
    width: remCalc(10),
  },
  scale: {
    left: `${remCalc(175)} !important`,
    top: '56vh !important',
    transform: 'scale(0.85)',
  },
}));

export default GreatAlphabetParadeIcon;
